import type { HomeTranslations } from '../../types';

export const frHome: HomeTranslations = {
  hero: {
    future: 'L\'avenir du chauffage',
    title: 'Efficace & \u00C9cologique',
    subtitle: 'Chauffage infrarouge',
    description: 'Apportez une chaleur semblable \u00E0 celle du soleil aux espaces ext\u00E9rieurs. Notre technologie infrarouge avanc\u00E9e offre une chaleur instantan\u00E9e, silencieuse et \u00E9cologique pour les \u00E9tablissements h\u00F4teliers, terrasses, jardins et zones de piscine.',
    cta: 'D\u00E9couvrir les produits',
    watchVideo: 'Regarder la vid\u00E9o',
    trusted: 'Approuv\u00E9 par plus de 5 000 clients',
    worldwide: 'Distribution mondiale',
    slides: {
      "slide5": {
        "title": "Foire de Canton",
        "subtitle": "Retrouvons-nous à Guangzhou",
        "description": "Rencontrez JH Heatsup à la Foire de Canton. Découvrez nos solutions de chauffage et nos possibilités de partenariat.",
        "exhibition": {
          "eyebrow": "JH HEATSUP · FOIRE DE CANTON",
          "date": "15–19 octobre 2026",
          "venue": "Complexe de la Foire de Canton, Guangzhou",
          "boothLabel": "NOTRE STAND",
          "booth": "Hall 3.2 · Stand L16"
        }
      },
      "slide4": {
        "title": "Global Sources",
        "subtitle": "Électronique grand public",
        "description": "Rencontrez JH Heatsup à Hong Kong. Découvrez nos solutions de chauffage et échangeons sur vos projets de partenariat.",
        "exhibition": {
          "eyebrow": "JH HEATSUP · SALON À HONG KONG",
          "date": "11–14 octobre 2026",
          "venue": "AsiaWorld-Expo, Hong Kong",
          "boothLabel": "NOTRE STAND"
        }
      },
      slide1: {
        title: 'Efficace & \u00C9cologique',
        subtitle: 'Chauffage infrarouge',
        description: 'Apportez une chaleur semblable \u00E0 celle du soleil aux espaces ext\u00E9rieurs. Notre technologie infrarouge avanc\u00E9e offre une chaleur instantan\u00E9e, silencieuse et \u00E9cologique pour les \u00E9tablissements h\u00F4teliers, terrasses, jardins et zones de piscine.',
      },
      slide2: {
        title: 'S\u00E9curis\u00E9 & Fiable',
        subtitle: 'Con\u00E7u pour un usage quotidien',
        description: 'Con\u00E7us avec des mat\u00E9riaux durables et des performances fiables, nos radiateurs offrent une chaleur stable et constante jour apr\u00E8s jour.',
      },
      slide3: {
        title: 'Ultra silencieux',
        subtitle: 'Une chaleur paisible',
        description: 'Profitez d\'une chaleur silencieuse et sans \u00E9blouissement, confortable et naturelle, qui n\u00E9 dess\u00E8che pas l\'air.',
      },
    },
  },
  about: {
    title: '\u00C0 propos de JH Heatsup',
    subtitle: 'Pionnier de la technologie infrarouge depuis 2006',
    intro1: 'Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) est un fabricant \u00E9co-technologique de premier plan sp\u00E9cialis\u00E9 dans les solutions de chauffage et de refroidissement \u00E9co-\u00E9nerg\u00E9tiques.',
    intro2: 'Nous nous concentrons sur la R&D, le marketing et un service client exceptionnel pour fournir des radiateurs infrarouges de haute qualit\u00E9. Nos produits respectent des normes de qualit\u00E9 strictes ISO9001:2000 et poss\u00E8dent des certifications telles que CE, CB, SAA et RoHS. Gr\u00E2ce \u00E0 notre engagement envers l\'innovation, nous sommes devenus le fabricant de radiateurs infrarouges \u00E0 la croissance la plus rapide en Chine.',
    stats: {
      yearsExperience: 'Ann\u00E9es d\'exp\u00E9rience',
      countriesExported: 'Pays export\u00E9s',
      patents: 'Brevets',
      satisfaction: 'Satisfaction',
    },
    ceoQuote: '\u00AB Nous nous engageons \u00E0 cr\u00E9er un monde plus vert et plus chaud gr\u00E2ce \u00E0 la technologie. \u00BB',
    ceoLabel: '- Message du PDG',
    factoryAlt: 'Ligne de production de l\'usine',
  },
  features: {
    title: 'Pourquoi choisir JH Heatsup',
    subtitle: 'Notre technologie infrarouge lointain imite le principe de chauffage naturel du soleil, r\u00E9chauffant directement les objets et les personnes plut\u00F4t que simplement l\'air.',
    energy: {
      title: '\u00C9co-\u00E9nerg\u00E9tique',
      desc: 'Jusqu\'\u00E0 99 % de conversion thermique pour des \u00E9conomies d\'\u00E9nergie maximales',
    },
    quiet: {
      title: 'Ultra silencieux',
      desc: 'Conception sans ventilateur avec z\u00E9ro bruit ni lumi\u00E8re',
    },
    safe: {
      title: 'S\u00E9curis\u00E9 & Fiable',
      desc: 'Indice de protection IPX4 avec protection contre la surchauffe int\u00E9gr\u00E9e',
    },
    smart: {
      title: 'Contr\u00F4le intelligent',
      desc: 'Connectivit\u00E9 Wi-Fi fluide pour le contr\u00F4le par application',
    },
  },
  categoriesSection: {
    title: 'Acheter par cat\u00E9gorie',
    subtitle: "Explorez nos radiateurs infrarouges, portables et à gaz pour trouver la solution adaptée à votre espace, des terrasses extérieures aux pièces de vie.",
    viewAll: 'Voir tous les produits',
    cards: {
      infrared: {
        badge: 'Populaire',
        tagline: 'Radiateurs infrarouges rayonnants pour une chaleur efficace et cibl\u00E9e',
        description: "Id\u00E9al pour les terrasses, les restaurants, les ateliers, les entrep\u00F4ts et le chauffage mural int\u00E9rieur.",
        cta: 'Acheter maintenant',
      },
      portable: {
        tagline: 'Radiateurs portables en fibre de carbone et halog\u00E8nes pour une chaleur flexible',
        description: "Parfait pour la maison, le bureau, le chauffage sous un bureau et les espaces de r\u00E9ception ext\u00E9rieurs.",
        cta: 'Acheter maintenant',
      },
      gas: {
        tagline: "Chauffages de terrasse à gaz et tables brasero pour le plein air",
        description: "Créez un espace extérieur chaleureux sur les terrasses de restaurants, dans les jardins et pour vos moments de convivialité.",
        cta: "Acheter maintenant",
      },
    },
  },
  ctaSection: {
    title: 'Pr\u00EAt \u00E0 am\u00E9liorer votre chauffage ?',
    subtitle: 'Contactez-nous d\u00E8s aujourd\'hui pour une consultation et un devis gratuits.',
    cta: 'Obtenir un devis',
  },
};
